import styles from './styles.module.scss';
import { Props } from './types';

const DetailElement = ({ caption, value, dynamicValue }: Props) => {
  return (
    <div className={styles.detailElement}>
      <p>{caption}</p>
      {value ? <span>{value}</span> : dynamicValue && dynamicValue()}
    </div>
  );
};

export default DetailElement;
